import { Component, OnInit, AfterViewInit, ElementRef, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { Toast, ToastType } from '../toast';
import { CommonModule } from '@angular/common';
declare var $: any;

@Component({
    selector: 'shared-toast',
    templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.css'],
  imports: [
    CommonModule
  ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastComponent implements OnInit, AfterViewInit {  

    @Input() toast!: Toast;
    @Output() toastHidden: EventEmitter<string> = new EventEmitter();
    className!: string;

    constructor(
        private element: ElementRef
    ) { }

    ngOnInit() {
        this.className = this.getClassName(this.toast.type);
    }

    ngAfterViewInit(): void {
        var self = this;
        let toastElement = this.element.nativeElement.firstChild;
        $(toastElement).toast('show');
        $(toastElement).on('hidden.bs.toast', function (e: any) {
            self.toastHidden.emit(self.toast.id);
        });
    }

    private getClassName(toastType: ToastType) {
        switch (toastType) {
            case  ToastType.Info:
                return 'toast-info';
            case ToastType.Success:
                return 'toast-success';
            case ToastType.Warning:
                return 'toast-warning';
            case ToastType.Error:
                return 'toast-danger';
            default: 
                return ''            
        }
    }
}
